export default "__VITE_ASSET__3c7fd51e__"